import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import CompressPDFCompressListScreen from "../compress_pdf/CompressPDFCompressListScreen";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function PdfUnder200KBMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Compress PDFs under 200 KB",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: {
      link: "/compress_pdf_under_200_kb",
      title: "Compress PDFs under 200 KB",
    },
    data2: {
      link: "/compress_pdf_under_200_kb",
      title: "Bulk Compress PDF files",
    },
    data3: { link: "/compress_pdf_under_200_kb", title: "PDFs under 200 kB" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Compress PDF under 200KB online easily. Reduce PDF file size for forms, uploads, and emails with our fast, secure PDF compressor tool."
      ></meta>
      <meta
        name="keywords"
        content="compress pdf under 200kb, pdf under 200kb, reduce pdf size to 200kb, compress pdf 200kb, pdf compressor under 200kb, make pdf 200kb, online pdf compressor, shrink pdf to 200kb, pdf size reducer, compress pdf for upload, compress pdf for email, pdf compression tool, reduce pdf file size, small pdf compressor, pdf optimizer"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <CompressPDFCompressListScreen
          title={title}
          scale_resolution={true}
          grayscale={true}
        />
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Compress PDFs under 200KB quickly and effortlessly with our powerful online PDF compressor designed for speed, quality, and convenience. This website helps you reduce PDF file size to 200KB or less without compromising document clarity, making it ideal for online form submissions, email attachments, job applications, government portals, and academic uploads. Using advanced compression algorithms, our PDF compression tool intelligently minimizes file size while preserving text readability, images, and formatting. Whether you need to shrink large PDF files, optimize PDFs for web upload, or meet strict file size limits, our tool delivers reliable results in seconds. No installation or technical skills are required—simply upload your file and compress PDFs online instantly from any device, including mobile, tablet, or desktop. This free PDF compressor supports secure processing, ensuring your files remain private while being compressed efficiently. Perfect for students, professionals, and businesses, our website allows you to reduce PDF size under 200KB, compress large PDFs, and optimize documents for fast sharing and storage. If you’re searching for the best PDF compressor online, reduce PDF file size without losing quality, or a quick solution to make PDF under 200KB, this platform is built to meet all your needs with accuracy and performance." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Compress",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Compress PDF to 200 KB"
            why_use={[
              {
                title: "Meet Online Upload Size Limits",
                description:
                  "Many government portals, job application websites, exam forms, and university submission systems require files to be under 200KB. Using a PDF compressor under 200KB helps you meet these strict upload limits without rejection.",
              },
              {
                title: "Faster File Upload and Download",
                description:
                  "Smaller PDF files upload and download much faster. When you compress PDF to 200KB, it reduces loading time, saves bandwidth, and improves user experience, especially on slow internet connections.",
              },
              {
                title: "Easy Email Sharing",
                description:
                  "Large PDFs often fail to send via email. By using a PDF size reducer, you can easily compress PDF files under 200KB and share documents quickly without email attachment issues.",
              },

              {
                title: "Save Device Storage Space",
                description:
                  "Compressed PDFs take up less storage on your mobile, tablet, or computer. A PDF compression tool helps reduce file size and keeps your device storage organized and efficient.",
              },
              {
                title: "Better Compatibility Across Platforms",
                description:
                  "Many websites and apps accept only lightweight files. When you reduce PDF file size under 200KB, your documents become compatible with more platforms and systems.",
              },
              {
                title: "No Loss of Document Quality",
                description:
                  "This online PDF compressor tools use smart compression techniques that maintain text clarity and readability while reducing file size, ensuring professional-quality documents.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students submitting assignments and professionals uploading resumes often need to make PDF under 200KB. A reliable PDF compressor online simplifies this task in seconds.",
              },
              {
                title: "Improves Website Performance",
                description:
                  "Smaller PDFs load faster on websites, improving page speed and SEO performance. Using compressed PDFs under 200KB helps optimize web content and user engagement.",
              },
              {
                title: "Secure and Hassle-Free Process",
                description:
                  "Our PDF compression websites offer secure processing without compromising file privacy. You can compress PDF online safely without installing any software.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I compress a PDF under 200 KB?",
                description:
                  "Use a PDF compression tool to reduce your document's file size to 200 KB or less. Upload or select your PDF, choose the available compression settings, and check the resulting file size. If the file remains too large, try stronger compression or reduce image resolution.",
              },
              {
                title: "How do I reduce PDF size to 200 KB online for free?",
                description:
                  "Open ShivaPDF's PDF compression tool, select your PDF file, and start compression. Check the output size after processing. Reaching 200 KB depends on the original file size, number of pages, images, fonts, and the compression settings available.",
              },
              {
                title: "What does compress PDF under 200 KB mean?",
                description:
                  "Compressing a PDF under 200 KB means reducing its total file size to 200 kilobytes or less. This can help meet document upload limits for online forms, applications, email attachments, and other services.",
              },
              {
                title: "Can I compress a PDF to exactly 200 KB?",
                description:
                  "PDF compression tools usually reduce file size rather than guarantee an exact target. If you need a file under a strict 200 KB limit, aim slightly below 200 KB to allow for differences in how file sizes are measured.",
              },
              {
                title: "Can I compress a PDF under 200 KB without losing quality?",
                description:
                  "Reducing a PDF's file size can affect image quality, especially when the document contains photos or scanned pages. Text-based PDFs may compress with little visible change, but aggressive image compression can reduce clarity. Review the output before submitting it.",
              },
              {
                title: "Can I compress a scanned PDF under 200 KB?",
                description:
                  "Yes, scanned PDFs can often be compressed by reducing image resolution, optimizing images, or using more efficient encoding. However, documents with many high-resolution scans may need stronger compression to reach 200 KB, which can affect readability.",
              },
              {
                title: "Can I compress a PDF with images under 200 KB?",
                description:
                  "Yes, PDFs containing images may be reduced by optimizing image resolution and compression. The achievable size depends on the number, dimensions, and original quality of the images, along with the number of pages.",
              },
              {
                title: "Can I reduce a multi-page PDF to under 200 KB?",
                description:
                  "It may be possible to compress a multi-page PDF under 200 KB, but the result depends on its content and page count. Documents with mostly text are generally easier to compress than image-heavy or scanned PDFs.",
              },
              {
                title: "Can I compress a PDF under 200 KB offline?",
                description:
                  "Offline compression is possible when the PDF compression engine and required resources are available locally on your device. If ShivaPDF's tool supports local browser processing, you may be able to compress files without sending them to a remote processing server after the tool has loaded.",
              },
              {
                title: "Does ShivaPDF compress PDF files locally?",
                description:
                  "Local processing depends on the tool's implementation. If the PDF compression tool processes files entirely in your browser, the document can be compressed on your device instead of being uploaded to a processing server. Check the tool's privacy information to confirm how files are handled.",
              },
              {
                title: "Is it safe to compress a PDF locally?",
                description:
                  "Processing files locally in your browser can help keep document contents on your device. For sensitive documents, verify that the tool performs compression locally and review its privacy policy before use.",
              },
              {
                title: "Can I use a PDF compressor under 200 KB for free?",
                description:
                  "A free PDF compressor can help reduce document size without requiring a paid desktop application. Check ShivaPDF's current tool page for its pricing, usage limits, and any restrictions on file size or compression.",
              },
              {
                title: "Do I need to install software to compress a PDF under 200 KB?",
                description:
                  "A browser-based PDF compression tool can work without a separate desktop installation. Open the tool in a supported browser, select your document, and follow the available compression steps.",
              },
              {
                title: "How can I compress a PDF under 200 KB on Windows or Mac?",
                description:
                  "Open ShivaPDF's PDF compression tool in a supported browser on Windows or macOS. Select your PDF, run compression, and verify that the resulting file is below 200 KB before using it.",
              },
              {
                title: "Can I compress a PDF under 200 KB on an iPhone or Android phone?",
                description:
                  "You may be able to compress a PDF using a mobile browser. Processing speed and results depend on your device, browser, document size, and the compression features supported by the tool.",
              },
              {
                title: "Why is my PDF still larger than 200 KB after compression?",
                description:
                  "A PDF may remain above 200 KB if it contains high-resolution images, scanned pages, embedded fonts, or complex graphics. Try stronger compression if available, lower image resolution, or remove unnecessary pages and content.",
              },
              {
                title: "How do I compress a PDF from 1 MB to under 200 KB?",
                description:
                  "Reducing a 1 MB PDF to under 200 KB requires cutting its size by more than 80%. This may be achievable for some documents using image optimization and stronger compression, but the result depends on the original content and acceptable quality.",
              },
              {
                title: "Will compressing a PDF under 200 KB remove text or images?",
                description:
                  "Compression aims to reduce file size while retaining document content. However, aggressive settings can reduce image detail or affect readability. Check the compressed PDF to ensure that important text, images, and page content remain usable.",
              },
              {
                title: "Can I compress a PDF under 200 KB for an online application?",
                description:
                  "Yes, a compressed PDF can be useful when an online application specifies a 200 KB maximum. Always check the application's exact file-size requirement, accepted file formats, and readability rules before uploading your document.",
              },
              {
                title: "Is 200 KB the same as 200 MB?",
                description:
                  "No. A kilobyte (KB) is much smaller than a megabyte (MB). A 200 KB file is roughly one-fifth of a megabyte using the decimal convention, whereas a 200 MB file is vastly larger.",
              },
              {
                title: "Can I compress a password-protected PDF under 200 KB?",
                description:
                  "A password-protected PDF may need to be unlocked before compression, depending on the tool. Only process documents you are authorized to access and follow the supported steps for protected files.",
              },
              {
                title: "Does compressing a PDF change the original file?",
                description:
                  "A PDF compressor typically produces a separate compressed file, leaving the original document unchanged. Keep the original if you need a higher-quality copy or want to compare the results.",
              },
              {
                title: "How can I check whether my PDF is under 200 KB?",
                description:
                  "After compression, check the file size in your device's file manager or file properties. Make sure the resulting file is below the limit required by your destination, and open it to confirm that the content is readable.",
              },
              {
                title: "Why should I use ShivaPDF to compress PDF under 200 KB?",
                description:
                  "ShivaPDF's PDF compression tool is intended to help users reduce PDF file sizes for easier sharing and uploads. Visit the tool page to check its current compression options, supported devices, usage limits, and privacy details.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1609168763}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default PdfUnder200KBMain;
